import React, { useRef } from 'react'
import { Toast } from 'primereact/toast'
import { FaCopy } from 'react-icons/fa'

// Custom component for the copyable UUID column
const CopyableUuidBody = ({ id }: { id: string }) => {
  const toast = useRef<Toast>(null)

  const handleCopy = () => {
    navigator.clipboard.writeText(id)
    toast.current?.show({
      severity: 'success',
      summary: 'Copied',
      life: 2000,
    })
  }

  return (
    <>
      <Toast ref={toast} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: .5,
          width: '100%',
        }}
      >
        <span
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            // flex: 1,
          }}
          title={id || ''} // Full UUID on hover
        >
          {id ? `${id.slice(0, 10)}...` : 'N/A'}
        </span>
        {id &&
          <button
            className="p-button p-button-text p-button-sm"
            style={{ color: 'var(--primary-color)' }}
            title="Copy"
            onClick={handleCopy}
          >
            <FaCopy />
          </button>
        }
      </div>
    </>
  )
}

// Wrapper to use in DataTable body
const CopyableUuidBodyWrapper = ({ rowData, keyIndex }: { rowData: any, keyIndex: string }) => {
  console.log(rowData, keyIndex, rowData[keyIndex])
  return <CopyableUuidBody id={rowData[keyIndex]} />
}

export default CopyableUuidBodyWrapper